import { render, staticRenderFns } from "./SelectFabricAccessory.vue?vue&type=template&id=718c2358&scoped=true"
import script from "./SelectFabricAccessory.vue?vue&type=script&lang=js"
export * from "./SelectFabricAccessory.vue?vue&type=script&lang=js"
import style0 from "./SelectFabricAccessory.vue?vue&type=style&index=0&id=718c2358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718c2358",
  null
  
)

export default component.exports